import fetch from 'auth/FetchInterceptor'

const MenuService = {}

MenuService.selectMenuListByAuthorities = function () {
  return fetch({
    url: '/menu/select-menu-list-by-authorities',
    method: 'post',
    headers: { 'X-Http-Method-Override': 'GET' },
  })
}

MenuService.selectBookmarkListByUserId = function () {
  return fetch({
    url: '/menu/select-bookmark-list-by-user-id',
    method: 'post',
    headers: { 'X-Http-Method-Override': 'GET' },
  })
}

MenuService.selectMenuButtonListByAuthorities = function () {
  return fetch({
    url: '/menu/select-menu-button-list-by-authorities',
    method: 'post',
    headers: { 'X-Http-Method-Override': 'GET' },
  })
}

/**
 * Bookmark 를 입력 한다.
 *
 * @param data
 * @returns {AxiosPromise}
 */
MenuService.insertBookmark = data => {
  return fetch({
    url: '/menu/insert-bookmark',
    method: 'post',
    data: data,
  })
}

/**
 * Bookmark 를 삭제 한다.
 *
 * @param data
 * @returns {AxiosPromise}
 */
MenuService.deleteBookmark = data => {
  return fetch({
    url: '/menu/delete-bookmark',
    method: 'post',
    data: data,
    headers: { 'X-Http-Method-Override': 'DELETE' },
  })
}

export default MenuService
